<template>
  <div class="lad-slider">
    <Swiper
      v-if="items.length > 1"
      :ref="reference"
      :options="swiperOption"
      :style="swiperStyles"
    >
      <SwiperSlide
        v-for="(item, i) in items"
        :key="item.uuid"
        :data-swiper-slide-index="i"
        :class="[fit === 'cover' ? 'cover-slide' : '']"
      >
        <LadImage
          :src="item.url"
          :srcset="item.srcset"
          :max-width="800"
          :alt="$t(`components.slider.photo_number`, { title, number: i + 1 })"
          :title="
            $t(`components.slider.photo_number`, { title, number: i + 1 })
          "
          :quality="currentItem === i ? 85 : 1"
          :class="['swiper-lazy', `ex-day-slide-${i}`, i === 0 ? 'load' : '']"
        />
      </SwiperSlide>

      <div slot="pagination" class="swiper-pagination" />
      <div slot="button-prev" class="swiper-button-prev" />
      <div slot="button-next" class="swiper-button-next" />
    </Swiper>

    <LadImage
      v-else
      :src="firstImage.url"
      :srcset="firstImage.srcset"
      :max-width="800"
      :alt="title"
      :title="title"
      :style="swiperStyles"
      class="image--cover"
    />
  </div>
</template>

<script>
import { uuidv4 } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'LadItinerarySlider',
  components: {
    LadImage: () =>
      import(
        /* webpackChunkName: "lad-image" */ '@/components/frontends/Image/index'
      ),
  },
  props: {
    items: { type: Array, default: () => [] },
    height: { type: String, default: 'auto' },
    maxHeight: { type: String, default: 'auto' },
    fit: { type: String, default: '' },
    isTest: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    const reference = `exerienceDaySlider-${uuidv4()}`
    const _this = this

    return {
      reference,
      currentItem: 0,
      loaded: [0],
      swiperOption: {
        autoHeight: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          slideChange() {
            /**
             * por algun motivo que aun desconozco aqui hay que trabajar con `_this` y con `this`
             */
            const wrapper = this.$el[0]
            const index = this.realIndex
            const slide = `ex-day-slide-${index}`
            const elements = wrapper.getElementsByClassName(slide)

            _this.currentItem = index
            _this.loaded.push(index)

            for (let i = 0; i < elements.length; i++) {
              if (!elements[i].classList.contains('load')) {
                elements[i].classList.add('load')
              }
            }
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    swiperStyles() {
      const styles = {
        maxHeight: this.maxHeight,
        height: this.height,
      }

      if (this.fit === 'cover') {
        styles.alignItems = 'center'
        styles.display = 'flex'
      }

      return styles
    },
    firstImage() {
      const defaultImage = { url: null }

      return this.items[0] || defaultImage
    },
    isLoaded() {
      return this.loaded.includes(this.currentItem)
    },
  },
  watch: {
    items(val) {
      this.handleUpdate()
    },
    isTest: {
      immediate: true,
      handler(value) {
        if (value && !this.isMobile) {
          this.swiperOption.slidesPerView = 3

          if (process.client && window.innerWidth < 1200) {
            this.swiperOption.slidesPerView = 2
          }

          this.swiperOption.spaceBetween = 10
        }
      },
    },
  },
  created() {
    if (this.fit === 'cover') {
      this.swiperOption.autoHeight = false
    }
  },
  mounted() {
    const count = setTimeout(() => {
      clearTimeout(count)

      /** no quitar ...para correcta inicializacion de slider */
      window.dispatchEvent(new Event('resize'))
    }, 2000)
  },
  methods: {
    handleUpdate() {
      const slider = this.$refs[this.reference]

      if (slider) {
        slider.$swiper.activeIndex = 1
        slider.updateSwiper()
      }
    },
  },
}
</script>

<style lang="scss">
.lad-slider {
  // .swiper-wrapper {
  //   height: auto;
  //   min-height: 420px;
  // }

  & > img,
  .swiper-slide img {
    width: 100%;
    display: block;
  }

  .cover-slide {
    display: flex;
    height: auto;

    img {
      object-fit: cover;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    background-color: white;
    background-size: 10px;
    border-radius: 50%;
    padding: 10px;
    height: 30px;
    width: 30px;
  }

  @media screen and (max-width: 480px) {
    .swiper-button-prev,
    .swiper-button-next {
      display: block;
    }
  }
}
</style>
